export default __webpack_public_path__ + "static/compare-table@3x-fce4a5efbc6b0049f34295b1d5a96ddd.png";